
import Vue, { PropType } from 'vue'
import Image from '@/models/Image'

// import JImageNote from '@/ui/controls/JImageNote.vue'
import JImageCard from '@/ui/controls/JImageCard.vue'

export default Vue.extend({
  components: {
    // JImageNote,
    JImageCard,
  },
  props: {
    value: String,
    // imageId: String,
    images: Array as PropType<Array<Image>>,

    hideClose: Boolean,
    dark: Boolean,
  },
  // data: () => ({
  //   errors: [] as Array<string>,
  // }),
  methods: {
    onCarouselChange(v: string) {
      this.$emit('change', v)
    },
    //   onError(v: string) {
    //     this.errors.push(v)
    //   },
    //   isError(url: string) {
    //     return this.errors.includes(url)
    //   },
    //   retryUrl(url: string) {
    //     const errorIndex = this.errors.indexOf(url)
    //     if (errorIndex >= 0) this.errors.splice(errorIndex, 1)
    //   },
  },
})
